/**
 * Global Chat Debug Configuration
 * Single source file defining all window debug flags and centralized debug logging helpers.
 */

if (typeof window !== 'undefined') {
  window.growtypeChatDebug = window.growtypeChatDebug ?? false;
  window.growtypeChatDebugRoleplayStep = window.growtypeChatDebugRoleplayStep ?? false;
  window.growtypeChatDebugRoleplayHeader = window.growtypeChatDebugRoleplayHeader ?? false;
  window.growtypeChatDebugGuestHistory = window.growtypeChatDebugGuestHistory ?? false;
  window.growtypeChatDebugVideoPoll = window.growtypeChatDebugVideoPoll ?? false;
  window.growtypeChatDebugKokoro = window.growtypeChatDebugKokoro ?? false;
  window.growtypeChatDebugInlineQuiz = window.growtypeChatDebugInlineQuiz ?? false;
}

/**
 * Returns true if debug is enabled globally or for a specific feature category.
 *
 * @param {string|null} category
 * @returns {boolean}
 */
export function isChatDebugEnabled(category = null) {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.growtypeChatDebug === true) {
    return true;
  }

  if (!category) {
    return false;
  }

  switch (category) {
    case 'roleplayStep':
      return window.growtypeChatDebugRoleplayStep === true;
    case 'roleplayHeader':
      return window.growtypeChatDebugRoleplayHeader === true;
    case 'guestHistory':
      return window.growtypeChatDebugGuestHistory === true;
    case 'videoPoll':
      return window.growtypeChatDebugVideoPoll === true;
    case 'kokoro':
      return window.growtypeChatDebugKokoro === true;
    case 'inlineQuiz':
      return window.growtypeChatDebugInlineQuiz === true;
    default: {
      const flagName = `growtypeChatDebug${category.charAt(0).toUpperCase() + category.slice(1)}`;
      return window[flagName] === true;
    }
  }
}

/**
 * Centralized debug logging helper. Logs to console only if debug is enabled
 * globally or for the specified category.
 *
 * @param {string|null} category
 * @param {...any} args
 */
export function chatDebugLog(category, ...args) {
  if (isChatDebugEnabled(category)) {
    console.log(...args);
  }
}
